import { CheckCircleIcon } from "lucide-react";
import "./verification-display-card.css";
export const VerificationDisplayCard = ({
  heading,
  img,
  link,
  subHeading,
  verificationBlips,
  gradientBottom = false,
  square,
}) => {
  return (
    <div className="r2-verification-card">
      <div className="r2-verification-card__content">
        <h2 className="r2-verification-card__title">
          {heading}
        </h2>
        <p className="r2-verification-card__subtitle">
          {subHeading}
        </p>
        <div className="r2-verification-card__list">
          {verificationBlips.map((copy, _index) => (
            <div key={copy.point}>
              <div className="r2-verification-card__item">
                <CheckCircleIcon className="r2-verification-card__icon" />
                <span className="r2-verification-card__item-text">
                  {copy.point}
                </span>
              </div>
              {copy.subscript && (
                <div className="r2-verification-card__subscript">
                  <sup className="r2-verification-card__subscript-index">
                    {copy.subscript.num}
                  </sup>
                  {copy.subscript.text}
                </div>
              )}
            </div>
          ))}
        </div>
        {link}
      </div>
      <div className="r2-verification-card__image">
        {img}
      </div>
      {gradientBottom && (
        <div className="r2-verification-card__gradient" />
      )}
    </div>
  );
};
